import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './MapBar.styles';

import Button from '../../inputs/button/Button';

export class MapBar extends Component {

  render() {
    return (
      <div className={css(styles.base)}>
        {!this.props.showLiveButton ?
          (<Button
            styles={styles.button}
            disabled={this.props.disableButtons}
            onClick={this.props.onStopClick}>
            <Translate value={this.props.stopButtonText || 'STOP'} />
          </Button>) :
          (<Button
            styles={styles.button}
            disabled={this.props.disableButtons}
            onClick={this.props.onLiveClick}>
            <Translate value={this.props.liveButtonText || 'LIVE'} />
          </Button>)}
      </div>
    );
  }
}

export default MapBar;



// WEBPACK FOOTER //
// ./src/components/common/mapBar/MapBar.js